exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Sweiper {\n  width: 100%;\n  overflow: hidden;\n  margin: 0 auto;\n  position: relative;\n}\n\n/* .box {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 1rem;\r\n  z-index: 50;\r\n  height: 1rem;\r\n  background-color: green;\r\n  width: 75%;\r\n}\r\n.boxs {\r\n  background-color: red;\r\n  transform: scale(0.83);\r\n} */", ""]);

// exports
